import React from "react";
import { Select } from 'antd';
import { conf_ID } from "../../utils/userProfiling";

const { Option } = Select;

const UserInfo = ({ user, isMe, highlightedPaper, setHighlightedPaper, paperRecommendation, interest }) => {
    const renderPapers = (papers) => {
        return papers
            .map((v, index) => 
            <p key={index}>
                <b>{v["title"]}</b> {v["conference"]} {v["year"]}<br/>
                <small>{v["authors"].map(a => a['name']).join(", ")}</small>
            </p>
        );
    }

    return (
        <>
            {/*<h4 className="text-muted">CSCW '22 publications:</h4>
            <div className="indent">
                {!("author" in user && (parseInt(user.author) >= 0) ) ?
                    "No paper at this conference"
                    : proceeding["papers"].filter(p => p["authors"].includes(user.author)).map((p, index) => 
                        <p key={index}>
                            <b>{p["title"]}</b> <br/>
                            {p["authors"].map((a, i) => {
                                return `${proceeding["authors"][a].split(": ")[0]} (${proceeding["authors"][a].split(": ")[1]}), `
                            })}
                        </p>)}
                        </div>*/}

        {conf_ID > 0 ?
        <>
            <h4 className="text-muted">Recent publications:</h4> {/* <TODO render based on paperRecommendation></> */}
            <div className="indent">
                {!user.prev_papers || Object.keys(user.prev_papers).length === 0 ?
                    "No previous publication"
                    :
                    (isMe? 
                        <>
                            <Select
                                showSearch
                                style={{width: "100%"}}
                                placeholder="Select a paper to recommend"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                { 
                                    console.log(input, option)
                                    return !option.children || option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    
                                }
                                filterSort={(optionA, optionB) =>
                                    !optionA.children.join || !optionB.children.join || optionA.children.join().toLowerCase().localeCompare(optionB.children.join().toLowerCase())
                                }
                                onSelect={(v) => {
                                    setHighlightedPaper({...user.prev_papers[v]}); 
                                }}
                            >
                                {Object.entries(user.prev_papers)
                                    .sort(([, a], [, b]) => b.year - a.year) // Sort by year in descending order
                                    .map(([key, value], index) => (
                                        <Option key={`pub-${index}`} value={key}>
                                        {value.title}
                                        </Option>
                                    ))}
                            </Select>
                            {"title" in highlightedPaper.current?
                                renderPapers([highlightedPaper.current])
                                :
                                renderPapers(Object.values(user.prev_papers).sort((a, b) => b.year - a.year).slice(0,3))
                        }</>
                        :
                        renderPapers(Object.values(user.prev_papers).sort((a, b) => b.year - a.year).slice(0,3))
                    )
                }
            </div>
        </> :
        <>
            <p><b>Interest: </b> {interest.charAt(0).toUpperCase() + interest.slice(1)}</p>
        </>}
        </>
    )
};

export default UserInfo;